// extracted by mini-css-extract-plugin
export default {"audio_modal":"AfterShare_audio_modal__WUboA","continue_btn":"AfterShare_continue_btn__Rkfo5","close_btn":"AfterShare_close_btn__HHpta"};